"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rezzato": {
    "fb07dc0f": [{
      "hkey": "acfb8dd3",
      "slug": "rezzato",
      "name": "Rezzato",
      "primary": true,
      "skipSearch": false
    }],
    "treponti": [{
      "hkey": "acfb8dd3",
      "slug": "rezzato",
      "name": "Rezzato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1ecb906b": [{
      "hkey": "acfb8dd3",
      "slug": "rezzato",
      "name": "Rezzato",
      "primary": true,
      "skipSearch": false
    }],
    "virle": [{
      "hkey": "acfb8dd3",
      "slug": "rezzato",
      "name": "Rezzato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;